import { gql } from 'graphql-request'

export const addClientToEquipmentQueue = gql`
  mutation AddClientToEquipmentQueue($clientId: String!, $equipmentId: String!) {
    addClientToEquipmentQueue(clientId: $clientId, equipmentId: $equipmentId) {
      equipmentId
    }
  }
`

export const removeClientFromEquipmentQueue = gql`
  mutation RemoveClientFromEquipmentQueue($clientId: String!, $equipmentId: String!) {
    removeClientFromEquipmentQueue(clientId: $clientId, equipmentId: $equipmentId) {
      equipmentId
    }
  }
`

export const notifyClientInEquipmentQueue = gql`
  mutation NotifyClientInEquipmentQueue(
    $siteId: String!
    $equipmentId: String!
    $clientId: String!
  ) {
    notifyClientInEquipmentQueue(siteId: $siteId, equipmentId: $equipmentId, clientId: $clientId) {
      equipmentId
      status
    }
  }
`
